export default __webpack_public_path__ + "42d9445ed8d58d441a7a937a01d4d878.png";